export const borderStyleSubTitle = [
    {
        text: "Use the different styles of borders like:",
        code: 'border radius/border-color/border-width'
    },
    {
        text: '. Use of any components.'
    }
];

export const backgroundColorSubTitle = [
    {
        text: 'Use the ',
        code: '.bg-* '
    },
    {
        text: 'and ',
        code: '.alert-light-* '
    },
    {
        text: 'colors in yuri theme.Use of any components.'
    }
];

export const borderColorSubTitle = [
    {
        text: "Use the ",
        code: '.b-*/.b-t-*/.b-b-*/.b-l-*/.b-r-*'
    },
    {
        text: 'class for borders.'
    }
];

export const imageSubTitle = [
    {
        text: "Use the width and height of images class like: ",
        code: '.img-*'
    },
    {
        text: "and",
        code: '.img-h-*'
    },
    {
        text: '.'
    }
];

export const fontStyleSubTitle = [
    {
        text: "Use the font-style like: ",
        code: ' .f-s-* [normal/italic/oblique/initial/inherit]'
    },
    {
        text: '.'
    }
];

export const fontWeightSubTitle = [
    {
        text: "Use the font-weight classes like: ",
        code: '.f-w-* [100/300/400/600/700/900]'
    }
]

export const textColorSubTitle = [
    {
        text: "Use the text color for ",
        code: '.font-*'
    },
    {
        text: " class.",
    }
];

export const paddingSubTitle = [
    {
        text: "Use the padding classes like: ",
        code: '.p-* [10/15/20/25/30/35/40/45/50]'
    }
];

export const oneSidePaddingSubTitle = [
    {
        text: "Use the padding classes like: ",
        code: '.p-l-*/.p-r-*/.p-t-*/.p-b-*'
    }
];

export const marginSubTitle = [
    {
        text: "Use the margin classes like: ",
        code: '.m-* [10/15/20/25/30/35/40/45/50]'
    }
];

export const oneSideMarginSubTitle = [
    {
        text: "Use the margin classes like: ",
        code: '.m-l-*/.m-r-*/.m-t-*/.m-b-*'
    }
];

export const fontSizeSubTitle = [
    {
        text: "Use the font-size for ",
        code: '.f-* [14/16/18/20/22/24/26/28/30/32/34/36/38/40]'
    },
    {
        text: '.'
    }
];

export const bordersAndDisplaySubTitle = [
    {
        text: "Use border utilities to add or remove an element's borders.",
    }
];

export const borderColorData = [
    {
        id: 1,
        color: 'primary',
    },
    {
        id: 2,
        color: 'secondary',
    },
    {
        id: 3,
        color: 'success',
    },
    {
        id: 4,
        color: 'danger',
    },
    {
        id: 5,
        color: 'warning',
    },
    {
        id: 6,
        color: 'info',
    },
    {
        id: 7,
        color: 'dark',
    },
    {
        id: 8,
        color: 'light',
    }
];

export const additiveBorderData = ['border', 'border-top', 'border-bottom', 'border-start', 'border-end'];

export const additiveRadiusData = ['rounded', 'rounded-top', 'rounded-end', 'rounded-bottom', 'rounded-start', 'rounded-pill', 'rounded-circle', 'rounded-0'];

export const borderSideColorData = ['b-primary', 'b-t-primary', 'b-b-primary', 'b-l-primary', 'b-r-primary', 'b-secondary', 'b-t-secondary', 'b-b-secondary', 'b-l-secondary', 'b-r-secondary', 'b-success', 'b-t-success', 'b-b-success', 'b-l-success', 'b-r-success', 'b-danger', 'b-t-danger', 'b-b-danger', 'b-l-danger', 'b-r-danger', 'b-warning', 'b-t-warning', 'b-b-warning', 'b-l-warning', 'b-r-warning', 'b-info', 'b-t-info', 'b-b-info', 'b-l-info', 'b-r-info', 'b-dark', 'b-t-dark', 'b-b-dark', 'b-l-dark', 'b-r-dark', 'b-light', 'b-t-light', 'b-b-light', 'b-l-light', 'b-r-light'];

export const imageData = ['30', '40', '50', '60', '70', '80', '90', '100'];

export const fontStyleData = ['normal', 'italic', 'oblique', 'initial', 'inherit']

export const fontWeightData = [
    {
        class: '100',
        text: 'You can set light font weight heading .f-w-100'
    },
    {
        class: '300',
        text: 'You can set light font weight heading .f-w-300'
    },
    {
        class: '400',
        text: 'You can set light font weight heading .f-w-400'
    },
    {
        class: '600',
        text: 'You can set bolder font weight heading .f-w-600'
    },
    {
        class: '700',
        text: 'You can set bold font weight heading .f-w-700'
    },
    {
        class: '900',
        text: 'You can set bold font weight heading .f-w-900'
    }
]

export const textColorsData = [
    {
        class: 'font-primary',
        text: 'This is a ',
        text2: 'text used class as .font-primary'
    },
    {
        class: 'font-secondary',
        text: 'This is a ',
        text2: 'text used class as .font-secondary'
    },
    {
        class: 'font-success',
        text2: 'text used class as .font-success',
        text: 'This is a '
    },
    {
        class: 'font-danger',
        text2: 'text used class as .font-danger',
        text: 'This is a '
    },
    {
        class: 'font-warning',
        text2: 'text used class as .font-warning',
        text: 'This is a '
    },
    {
        class: 'font-info',
        text2: 'text used class as .font-info',
        text: 'This is a '
    },
    {
        class: 'font-dark',
        text2: 'text used class as .font-dark',
        text: 'This is a '
    }
]

export const fontSizeData = [14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40]

export const paddingList = [10, 15, 20, 25, 30, 35, 40, 45, 50];

export const oneSidePaddingData = [
    {
        id: 1,
        title: 'Left',
        box: [
            {
                id: 1,
                text: 'l-10'
            },
            {
                id: 2,
                text: 'l-15'
            },
            {
                id: 3,
                text: 'l-20'
            },
            {
                id: 4,
                text: 'l-25'
            },
            {
                id: 5,
                text: 'l-30'
            },
            {
                id: 6,
                text: 'l-35'
            },
            {
                id: 7,
                text: 'l-40'
            },
            {
                id: 8,
                text: 'l-45'
            },
            {
                id: 9,
                text: 'l-50'
            },
        ]
    },
    {
        id: 2,
        title: 'Right',
        box: [
            {
                id: 1,
                text: 'r-10'
            },
            {
                id: 2,
                text: 'r-15'
            },
            {
                id: 3,
                text: 'r-20'
            },
            {
                id: 4,
                text: 'r-25'
            },
            {
                id: 5,
                text: 'r-30'
            },
            {
                id: 6,
                text: 'r-35'
            },
            {
                id: 7,
                text: 'r-40'
            },
            {
                id: 8,
                text: 'r-45'
            },
            {
                id: 9,
                text: 'r-50'
            },
        ]
    },
    {
        id: 3,
        title: 'Top',
        box: [
            {
                id: 1,
                text: 't-10'
            },
            {
                id: 2,
                text: 't-15'
            },
            {
                id: 3,
                text: 't-20'
            },
            {
                id: 4,
                text: 't-25'
            },
            {
                id: 5,
                text: 't-30'
            },
            {
                id: 6,
                text: 't-35'
            },
            {
                id: 7,
                text: 't-40'
            },
            {
                id: 8,
                text: 't-45'
            },
            {
                id: 9,
                text: 't-50'
            },
        ]
    },
    {
        id: 4,
        title: 'Bottom',
        box: [
            {
                id: 1,
                text: 'b-10'
            },
            {
                id: 2,
                text: 'b-15'
            },
            {
                id: 3,
                text: 'b-20'
            },
            {
                id: 4,
                text: 'b-25'
            },
            {
                id: 5,
                text: 'b-30'
            },
            {
                id: 6,
                text: 'b-35'
            },
            {
                id: 7,
                text: 'b-40'
            },
            {
                id: 8,
                text: 'b-45'
            },
            {
                id: 9,
                text: 'b-50'
            },
        ]
    }
]